import CompaniesCreate from "@/components/pages/sales/companies/Create.vue";
import CompaniesEdit from "@/components/pages/sales/companies/Edit.vue";
import CompaniesList from "@/components/pages/sales/companies/Index.vue";

export default [
	{
		name: "CompaniesList",
		path: "/sales/companies",
		component: CompaniesList,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜顧客一覧",
			column: "after_login"
		}
	},
	{
		name: "CompaniesCreate",
		path: "/sales/companies/create",
		component: CompaniesCreate,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜顧客新規作成",
			column: "after_login"
		}
	},
	{
		name: "CompaniesEdit",
		path: "/sales/companies/:id/edit",
		component: CompaniesEdit,
		meta: {
			requiresAuth: false,
			title: "KIZUNAコンパス管理システム｜顧客編集",
			column: "after_login"
		}
	}
];
